import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Download from 'yet-another-react-lightbox/plugins/download';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/styles.css';
import './LightboxGallery.css';
import type { Theme } from '@mui/material';
import type { FC } from 'react';
import type { MediaData } from '../../../models';
import { handleMediaSlides } from '../../Functions/handleMediaSlides';

type Props = {
  open: boolean;
  index: number;
  handleClose: () => void;
  imageSrc: MediaData[];
  theme: Theme;
};

export const LightboxGallery: FC<Props> = ({ open, index, imageSrc, handleClose, theme }) => {
  const hideControlls = imageSrc.length === 1;
  return (
    <Lightbox
      open={open}
      index={index}
      plugins={[Zoom, Download, Video, Captions]}
      captions={{ showToggle: true, descriptionTextAlign: 'center' }}
      close={handleClose}
      zoom={{ maxZoomPixelRatio: 10 }}
      slides={handleMediaSlides(imageSrc)}
      styles={{
        button: { color: 'white', filter: 'none' },
        container: { backgroundColor: 'white' },
        navigationNext: {
          ...(hideControlls && { display: 'none' }),
          backgroundColor: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          borderRadius: '80px',
          padding: '9px',
          marginRight: '18px'
        },
        navigationPrev: {
          ...(hideControlls && { display: 'none' }),
          backgroundColor: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          borderRadius: '80px',
          padding: '9px',
          marginLeft: '18px'
        },
        toolbar: {
          color: 'red',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)'
        }
      }}
    />
  );
};
